import React, { FC } from 'react';
import injectSheet from 'react-jss';
import styleSheet from './styles';
import TableHeader from './TableHeader';
import TableRow from './TableRow';
import TableCell from './TableCell';
import TableBody from './TableBody';
import TableSelectedItem from './TableSelectedItem';
import TableInterestBars from './TableInterestBars';

interface Props {
  overflowx?: any;
  overflowy?: any;
  padding?: string;
  paddingTop?: string;
  marginTop?: string;
  classes?: any;
  children?: React.ReactNode;
}

type Table<Props> = FC<Props> & {
  Header?: React.ReactNode;
  Row?: React.ReactNode;
  Cell?: React.ReactNode;
  Body?: React.ReactNode;
  SelectedItem?: React.ReactNode;
  InterestBars?: React.ReactNode;
  classes?: any;
};

const Table: Table<Props> = (props: Props) => {
  const {
    overflowx,
    overflowy,
    padding,
    paddingTop,
    marginTop,
    classes,
    children,
  } = props;
  return (
    <div
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      className={classes.tableDiv}
      style={{
        overflowX: overflowx,
        overflowY: overflowy,
        padding,
        paddingTop,
        marginTop,
      }}
    >
      {children}
    </div>
  );
};

Table.defaultProps = {
  overflowx: undefined,
  overflowy: undefined,
  padding: undefined,
  paddingTop: undefined,
  marginTop: undefined,
  classes: {},
  children: null,
};

// Subclasses //
Table.Header = TableHeader;
Table.Row = TableRow;
Table.Cell = TableCell;
Table.Body = TableBody;
Table.SelectedItem = TableSelectedItem;
Table.InterestBars = TableInterestBars;

export default injectSheet(styleSheet)(Table);
